import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const ImageMarker = ({
  src,
  title,
  caption,
  source,
  colorMode = 'light',
}: {
  src: string
  title?: string
  caption?: string
  source?: string
  colorMode?: 'light' | 'dark'
}) => {
  const { width } = useWindowSize()
  const [imageWidth, setImageWidth] = useState(100)
  useEffect(() => {
    setImageWidth(width < 712 ? width - 100 : 552)
  }, [width])
  return (
    <MarkerContainer width={imageWidth} colorMode={colorMode}>
      <img src={src} alt={title} />
      <Spickel colorMode={colorMode} />
      <InfoContainer colorMode={colorMode}>
        {title && <Title>{title}</Title>}
        {caption && <Caption>{caption}</Caption>}
        {source && <Source>{source}</Source>}
      </InfoContainer>
    </MarkerContainer>
  )
}

const MarkerContainer = styled.div<{
  width: number
  colorMode: 'light' | 'dark'
}>`
  max-width: ${({ width }) => width + 'px'};

  width: ${({ width }) => width + 'px'};
  transform: translate(0, calc(-50% - 20px));
  border-bottom: ${({ colorMode }) =>
    colorMode === 'light'
      ? '6px solid #202346'
      : '6px solid var(--text-color)'};
  line-height: 0;
  z-index: 4;
  position: relative;
  img {
    max-width: 100%;
  }
`
const Title = styled.div`
  font-size: 15px;
  font-weight: 700;
`
const Caption = styled.div`
  font-size: 14px;
`
const Source = styled.div`
  opacity: 0.7;
`
const InfoContainer = styled.div<{ colorMode: 'light' | 'dark' }>`
  font-size: 12px;
  width: calc(100% - 15px);
  padding-left: 15px;
  padding-top: 1em;
  padding-bottom: 0.5em;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  background-color: ${({ colorMode }) =>
    colorMode === 'light' ? '#121212' : 'var(--text-color)'};
  color: ${({ colorMode }) =>
    colorMode === 'light'
      ? 'var(--site-background)'
      : 'var(--site-background)'};

  line-height: 22px;
  * {
    flex: 0 0 100%;
  }
`
const Spickel = styled.div<{ colorMode: 'light' | 'dark' }>`
  position: absolute;
  bottom: -21px;
  left: calc(50% - 20px);
  width: 0;
  height: 0;
  border-top: ${({ colorMode }) =>
    colorMode === 'light'
      ? '20px solid #121212'
      : '20px solid var(--text-color)'};

  border-right: 20px solid transparent;
  border-left: 20px solid transparent;
`
